import React from 'react';
import { ContentGridItem } from './content-grid-item.react-component';
/**
 * ### ContentGridItemFullWidth
 *
 * @remarks
 *
 * Convenience component to render a `ContentGridItem` that consumes a full
 * grid row. Specifically, 4 columns when the grid is narrow, and 12 when it
 * is wide. It will not fill rows that do not include the full complement of
 * columns.
 */

export const ContentGridItemFullWidth = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ContentGridItem, Object.assign({
    defaultSpan: 4,
    wideSpan: 12
  }, props), children);
};
//# sourceMappingURL=content-grid-item-full-width.react-component.js.map